module.exports = __webpack_public_path__ + "img/en.8987950d.svg";